import { PasswordSection } from '@/Components';
import React from 'react';

export const ResetPasswordFragment = () => {
    return (
        <>
            <h2 className="text-2xl font-bold mb-4">Change Password</h2>
            <PasswordSection />
        </>
    )
}

